import { render, staticRenderFns } from "./NotificationCenter.vue?vue&type=template&id=b752af0c&scoped=true&"
import script from "./NotificationCenter.vue?vue&type=script&lang=js&"
export * from "./NotificationCenter.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCenter.vue?vue&type=style&index=0&id=b752af0c&lang=scss&scoped=true&"
import style1 from "./NotificationCenter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b752af0c",
  null
  
)

export default component.exports